import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/Login'
import Main from '@/pages/Main'
import WhiteList from '@/pages/WhiteList'
import Map from '@/pages/Map'
import PeriodTask from '@/pages/PeriodTask'
import DeviceInfo from '@/pages/DeviceInfo'
import Device from '@/pages/Device'
import TaskRdAll from '@/pages/TaskRdAll'
import ScanRdAll from '@/pages/ScanRdAll'
import DeviceHeatmap from '@/pages/DeviceHeatmap'
import DeviceGridDensity from '@/pages/DeviceGridDensity'
import Chart from '@/pages/Chart'
import IllegalRadioGridDensity from '@/pages/IllegalRadioGridDensity'
import IllegalRadioConfirm from '@/pages/IllegalRadioConfirm'
import Keywords from '@/pages/Keywords'
import MapAPI from '@/pages/MapAPI'
import TaskStat from '@/pages/TaskStat'
import RadioStat from '@/pages/RadioStat'
import RunningStat from '@/pages/RunningStat'
import OuterWarning from '@/pages/OuterWarning'
import InnerWarning from '@/pages/InnerWarning'
import ReportTemplate from '@/pages/ReportTemplate'
import ReportDownload from '@/pages/ReportDownload'



Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/MapAPI',
      name: 'MapAPI',
      component: MapAPI
    },
    {
      path: '/main',
      name: 'Main',
      component: Main,
      children: [{
          path: '/',
          component: Chart
        },
        {
          path: '/WhiteList',
          component: WhiteList
        },
        {
          path: '/Map',
          component: Map
        },
        {
          path: '/PeriodTask',
          component: PeriodTask
        },
        {
          path: '/Device',
          component: Device
        },
        {
          path: '/DeviceInfo/:lgid',
          component: DeviceInfo
        },
        {
          path: '/TaskRdAll',
          component: TaskRdAll
        },
        {
          path: '/ScanRdAll',
          component: ScanRdAll
        },
        {
          path: '/DeviceHeatmap',
          component: DeviceHeatmap
        },
        {
          path: '/DeviceGridDensity',
          component: DeviceGridDensity
        },
        {
          path: '/IllegalRadioGridDensity',
          component: IllegalRadioGridDensity
        },
        {
          path: '/IllegalRadioConfirm',
          component: IllegalRadioConfirm
        },
        {
          path: '/Keywords',
          component: Keywords
        },
        {
          path: '/TaskStat',
          component: TaskStat
        },
        {
          path: '/RadioStat',
          component: RadioStat
        },
        {
          path: '/RunningStat',
          component: RunningStat
        },
        {
          path: '/OuterWarning',
          component: OuterWarning
        },
        {
          path: '/InnerWarning',
          component: InnerWarning
        },
        {
          path: '/ReportTemplate',
          component: ReportTemplate
        },
        {
          path: '/ReportDownload',
          component: ReportDownload
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js